import request, { Methods, withToken } from "../../../../assets/util/request";

//* ACTIONTYPES --------------------------------------------
export const GET_INVOICE_CLIENT_LOADING = 'GET_INVOICE_CLIENT_LOADING';
export const GET_INVOICE_CLIENT_SUCCESS = 'GET_INVOICE_CLIENT_SUCCESS';
export const GET_INVOICE_CLIENT_REJECT  = 'GET_INVOICE_CLIENT_REJECT';

//* ACTIONS ------------------------------------------------
export const getInvoiceClientLoading = () => ({ type: GET_INVOICE_CLIENT_LOADING });
export const getInvoiceClientSuccess = (payload) => ({ type: GET_INVOICE_CLIENT_SUCCESS, payload });
export const getInvoiceClientReject  = (payload) => ({ type: GET_INVOICE_CLIENT_REJECT,  payload });

//* REQUEST SERVICE ----------------------------------------
export const getInvoiceClientRequest = async (params = {}, getState) => {
    const options = await withToken({
        method: Methods.GET,
        params,
    }, getState);
    return request(`/Invoices/web/GetAllInvoices`, options);
};
